<template>
  <Layout>
    <div v-if="!user" class="split">
      <div class="panel">
        <div class="panel-inner">
          <img class="logo" src="../../assets/images/white-knot.svg" alt="" />
          <h1>THE STYLIST<br />PROGRAM</h1>
          <p>Curate. Consign. Get paid. Log in with your Fashionphile account to get started.</p>
          <p v-if="loginError === 'not_a_stylist'" class="login-error">
            You're not enrolled in the Stylist Program — <a href="https://www.fashionphile.com/pages/stylist-program" class="login-error-link">learn more</a>.
          </p>
          <p v-else-if="loginError" class="login-error">{{ loginError }}</p>
          <button v-if="loginError === 'not_a_stylist'" class="btn btn-outline-light login-button" @click="redirectToLogout">LOG OUT</button>
          <button v-else class="btn btn-outline-light login-button" @click="redirectToLogin">LOGIN</button>
        </div>
      </div>
      <div class="image" :style="{ backgroundImage: `url(${image})` }"></div>
    </div>
  </Layout>
</template>
<script>
import Layout from '../layouts/main'
import { loginUrl, logoutUrl } from '@/services/storefront'
import image from '../../assets/images/login.png'

export default {
  data () {
    return {
      user: '',
      image
    }
  },
  components: {
    Layout
  },
  computed: {
    loginError () {
      return this.$store.state.loginError
    }
  },
  methods: {
    redirectToLogin () {
      window.location.href = loginUrl()
    },
    redirectToLogout () {
      this.$store.commit('logoutUser')
      window.location.href = logoutUrl()
    }
  },
  mounted () {
    document.body.setAttribute('data-layout', 'lightHeader')
    this.user = this.$store.state.stylist
  }
}
</script>
<style scoped>
/* Fixed below the topbar so the page-content/footer padding can't introduce scroll. */
.split {
  position: fixed;
  top: 70px;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  overflow: hidden;
  z-index: 1;
}
.panel {
  flex: 0 0 42%;
  /* Match the dark topbar ($header-dark-bg: $black) so panel and header read as one surface. */
  background: #000;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.panel-inner {
  padding: 48px;
  max-width: 480px;
  text-align: center;
}
.logo {
  height: 88px;
  margin-bottom: 40px;
}
.panel h1 {
  color: #fff;
  letter-spacing: 6px;
  font-size: 34px;
  line-height: 1.3;
  margin-bottom: 24px;
}
.panel p {
  color: #bbb;
  margin-bottom: 40px;
}
.panel .login-error {
  color: #ff6b6b;
  margin: -16px 0 32px;
}
.login-error-link {
  color: #fff;
  text-decoration: underline;
}
.login-error-link:hover {
  color: #ddd;
}
.login-button {
  letter-spacing: 3px;
  padding: 12px 48px;
  white-space: nowrap;
  color: #fff;
  border: 1px solid #fff;
  background: transparent;
  border-radius: 0;
}
.login-button:hover,
.login-button:focus,
.login-button:active {
  color: #000 !important;
  background: #fff !important;
  border-color: #fff !important;
  box-shadow: none;
}
.image {
  flex: 1;
  background-color: #f2f2f2;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
@media (max-width: 768px) {
  .split { flex-direction: column; }
  .panel { flex-basis: auto; flex: 1; }
  .image { min-height: 40%; }
}
</style>
